var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from "react";
/**
 * A hook to assist with components that transition between two states.
 * @param open The state of the component.
 * @param duration The duration of the transition.
 * @param opts Additional options
 */
export function useTransition(open, duration, opts) {
    if (opts === void 0) { opts = {}; }
    var _a = __read(React.useState("closed"), 2), state = _a[0], setState = _a[1];
    var timeoutRef = React.useRef(null);
    React.useEffect(function () {
        if (open && (state === "closed" || state === "closing")) {
            maybeClearTimeout(timeoutRef.current);
            setState("opening");
            maybeInvoke(opts.onOpenStart);
            timeoutRef.current = setTimeout(function () {
                setState("open");
                maybeInvoke(opts.onOpenComplete);
                timeoutRef.current = null;
            }, duration);
        }
        else if (!open && (state === "open" || state === "opening")) {
            maybeClearTimeout(timeoutRef.current);
            setState("closing");
            maybeInvoke(opts.onCloseStart);
            timeoutRef.current = setTimeout(function () {
                setState("closed");
                maybeInvoke(opts.onCloseComplete);
                timeoutRef.current = null;
            }, duration);
        }
    }, [open]);
    return state;
}
function maybeInvoke(f) {
    if (f) {
        f();
    }
}
function maybeClearTimeout(t) {
    if (t) {
        clearTimeout(t);
    }
}
//# sourceMappingURL=useTransition.js.map